// extracted by mini-css-extract-plugin
export default {"container":"style_container__x1jAC","supBackground":"style_supBackground__7RXZm","text":"style_text__gtYZT"};